import { useCallback, useState } from 'react'

export default function useModalManager (isVisible?: boolean): { openModal: () => void, closeModal: () => void, isModalVisible: boolean } {
  const [isModalVisible, setIsModalVisible] = useState(isVisible ?? false)

  const openModal = useCallback((): void => {
    setIsModalVisible(true)
  }, [])

  const closeModal = useCallback((): void => {
    setIsModalVisible(false)
  }, [])

  return { openModal, closeModal, isModalVisible }
};
